import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Typography,
  Avatar,
  Alert,
} from '@mui/material'
import { 
  Calculate,
  Male,
  Female,
} from '@mui/icons-material'

const BreedingCalculatorDialog = ({ 
  open, 
  onClose, 
  entry,
  entryId,
  entries,
  selectedMate,
  setSelectedMate,
  breedingResults,
  onCalculateBreeding
}) => {
  const selectedMateEntry = selectedMate ? entries.find(e => e.entryId === selectedMate) : null

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      fullScreen={false}
      PaperProps={{
        sx: { 
          margin: { xs: 1, sm: 2 },
          maxHeight: { xs: '90vh', sm: 'calc(100vh - 64px)' }
        }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Calculate color="primary" />
          Test Breeding Calculator
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <Alert severity="info">
            Select another bird from your flock to calculate potential breeding outcomes based on genetic traits.
          </Alert>
          
          <FormControl fullWidth>
            <InputLabel>Select Breeding Partner</InputLabel>
            <Select
              value={selectedMate}
              label="Select Breeding Partner"
              onChange={(e) => setSelectedMate(e.target.value)}
            >
              {entries
                .filter(e => e.entryId !== entryId && e.species === entry?.species)
                .map((bird) => (
                  <MenuItem key={bird.entryId} value={bird.entryId}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {bird.sex === 'male' ? <Male fontSize="small" /> : <Female fontSize="small" />}
                      <Typography>{bird.name} - {bird.breed}</Typography>
                    </Box>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {selectedMateEntry && (
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle2" gutterBottom>
                Selected Breeding Partner:
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ width: 40, height: 40 }}>
                  {selectedMateEntry?.sex === 'male' ? <Male /> : <Female />}
                </Avatar>
                <Box>
                  <Typography variant="body1">{selectedMateEntry?.name}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {selectedMateEntry?.breed} • {selectedMateEntry?.sex}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          )}

          {breedingResults && (
            <Alert severity="success">
              Breeding calculation complete! Results are displayed in the Genetics tab below.
            </Alert>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button 
          onClick={() => {
            onCalculateBreeding()
            onClose()
          }}
          variant="contained"
          disabled={!selectedMate}
          startIcon={<Calculate />}
        >
          Calculate Breeding
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default BreedingCalculatorDialog